import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const Phone = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fill="currentColor"
      d="M9.37 10.68c.93 1.65 2.3 3.02 3.95 3.95l.88-1.23a1 1 0 0 1 1.3-.3c1.41.77 2.97 1.24 4.58 1.36a1 1 0 0 1 .92 1v4.46a1 1 0 0 1-.9 1A15.51 15.51 0 0 1 3.08 3.9a1 1 0 0 1 1-.9h4.46a1 1 0 0 1 1 .92c.12 1.6.59 3.17 1.36 4.58a1 1 0 0 1-.3 1.3l-1.23.88Zm-2.53-.65 1.9-1.36C8.2 7.5 7.84 6.27 7.64 5H5.02v.5A13.5 13.5 0 0 0 19 18.99v-2.64c-1.27-.19-2.5-.55-3.67-1.1l-1.36 1.9c-.54-.2-1.07-.46-1.58-.74l-.06-.04a12.56 12.56 0 0 1-4.7-4.7l-.04-.06c-.28-.5-.53-1.04-.75-1.58Z"
    />
  </svg>
));
